($ => {

	const activeClass = 'active';
	const $tabs = $('.tabs-tab');
	const $tabPanels = $('.tabs-tabPanel');

	$tabs.on( 'click keypress', event => {
		try {
			if( event.which === 13 || event.type === 'click' ) {
				const $tab = $( event.target );
				const tabPanelId = $tab.attr( 'aria-controls' );

				if( ! tabPanelId ) throw new Error("Tab must have aria-controls attribute defined");

				const $tabsSection = $tab.parents('.tabs')
				const $tabPanel = $tabsSection.find(`#${tabPanelId}`);

				if( ! $tabPanel.length ) throw new Error(`Tab panel with ID #${tabPanelId} does not exist in DOM`);

				$tabsSection.find('.tabs-tabPanels').css( 'min-height', `${$tabPanel.outerHeight()}px` );

				$tabs.removeClass( activeClass ).attr( 'aria-selected', 'false' );
				$tab.addClass( activeClass ).attr( 'aria-selected', 'true' );

				$tabPanels.removeClass( activeClass ).attr( 'aria-selected', 'false' ).attr( 'tabindex', '-1' );
				$tabPanel.addClass( activeClass ).attr( 'aria-selected', 'true' ).attr( 'tabindex', '0' ).focus();

				$tabsSection.find('.tabs-tabPanels').css( 'min-height', '' );
			}
		}
		catch( error ) {
			console.log( error );
		}
	});

})(jQuery);



// WEBPACK FOOTER //
// ./js/components/tabs.js